import { type ReactElement, type ReactNode } from 'react'
import { isNotEmpty } from '@terros/common'
import { Text, Group } from '@mantine/core'
import { ColorPrimitives } from '@front/model'
import { MaterialSymbolIcon } from '../terros'

type Props = {
  label: string
  details?: string
  isSelected?: boolean
  leftSection?: ReactNode
}

export const DisplaySelectOption = ({ label, details, isSelected, leftSection }: Props): ReactElement => {
  return (
    <Group justify='space-between'>
      <Group flex={1} wrap='nowrap'>
        {leftSection}
        <div className='flex flex-1 flex-col gap-xs'>
          <Text size='sm'>{label}</Text>
          {isNotEmpty(details) && (
            <Text size='xs' c='dimmed'>
              {details}
            </Text>
          )}
        </div>
      </Group>
      {isSelected && <MaterialSymbolIcon icon='check' color={ColorPrimitives.blue['500']} size='lg' />}
    </Group>
  )
}
